'use client';
import * as React from 'react';
export function useTreeItemPersonaLayoutContextValues_unstable(state) {
    const { avatarSize } = state;
    const avatar = React.useMemo(()=>({
            size: avatarSize
        }), [
        avatarSize
    ]);
    return {
        avatar
    };
}
